import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/site";

export const Logo = ({ className = "", onDark = true, testId = "asai-logo" }) => (
  <Link
    to="/"
    data-testid={testId}
    className={`inline-flex items-center gap-3 ${className}`}
    aria-label="ASAI - Atmasamman School of AI, home"
  >
    <img
      src={ASSETS.logo}
      alt="ASAI logo"
      className="h-9 w-auto object-contain sm:h-10"
      style={{
        // logo art has a solid dark backdrop; blend it on dark, frame it on light
        mixBlendMode: onDark ? "screen" : "normal",
      }}
    />
  </Link>
);
